import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { LanguageProvider } from "@/context/LanguageContext";
import { Layout } from "@/components/site/Layout";
import { LANGS, detectLang, langFromPath, withLang } from "@/lib/lang";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import AboutPage from "@/pages/AboutPage";
import Support from "@/pages/Support";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

/**
 * Sends language-less URLs to a language-prefixed one, preserving the rest of
 * the path so previously shared links like /products keep working.
 */
const LangRedirect = () => {
  const { pathname, search, hash } = useLocation();
  if (langFromPath(pathname)) return null;
  return <Navigate to={`${withLang(detectLang(), pathname)}${search}${hash}`} replace />;
};

const pages = (
  <>
    <Route index element={<Home />} />
    <Route path="products" element={<Products />} />
    <Route path="products/:slug" element={<ProductDetail />} />
    <Route path="about" element={<AboutPage />} />
    <Route path="support" element={<Support />} />
    <Route path="contact" element={<Contact />} />
    <Route path="*" element={<NotFound />} />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* reducedMotion="user" makes framer-motion drop transform animations
            for visitors who ask for less motion, keeping opacity fades. */}
        <MotionConfig reducedMotion="user">
          <LanguageProvider>
            <Routes>
              {LANGS.map((lang) => (
                <Route key={lang} path={lang} element={<Layout />}>
                  {pages}
                </Route>
              ))}
              <Route path="*" element={<LangRedirect />} />
            </Routes>
          </LanguageProvider>
        </MotionConfig>
      </BrowserRouter>
    </div>
  );
}

export default App;
